import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, skipWhile, take } from 'rxjs/operators';
import { AuthFacade } from './state/auth.facade';

// ID-5: Pro Pool ID sends the web build back here with the authorization code. Waits until the stored session has
// loaded (that load would otherwise overwrite the new tokens), hands the URL to the login flow and moves on to the
// profile; loginOk$ takes it from there.
export const idCallbackGuard: CanActivateFn = (_, state) => {
	const authFacade = inject(AuthFacade);
	const router = inject(Router);
	return authFacade.loading$.pipe(
		skipWhile(loading => loading),
		take(1),
		map(() => {
			authFacade.completeLogin(new URL(state.url, window.location.origin).href);
			return router.parseUrl('/tabs/profile');
		})
	);
};
